<nz-page-header nzTitle="Member Bulk Upload"></nz-page-header>

<a [routerLink]="['/member/bulk/new']" nz-button nzType="dashed" class="mb-1" >+ New Upload</a>
<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
	<thead>
		<tr>
			<th>#</th>
			<th>When</th>
			<th>Agent</th>
			<th>Status</th>
			<th>Records Added</th>
			<th>Records Updated</th>
			<th>Invalid Records</th>
			<th>Failed Records</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data" (dblclick)="doView(item)">
			<td>{{item.id}}</td>
			<td>{{item.createdAt | date}}</td>
			<td>{{item.agent!.firstName}} {{item.agent!.lastName}}</td>
			<td>{{item.status}}</td>
			<td>{{item.insertCount}}</td>
			<td>{{item.updateCount}}</td>
			<td>{{item.invalidCount}}</td>
			<td>{{item.failedCount}}</td>
		</tr>
	</tbody>
</nz-table>
